import React from 'react'
import styled from 'styled-components'
import policeWalkieTalkie from "../../public/static/images/png/howItWorks/policeWalkieTalkie.png"
import noParking from "../../public/static/images/png/howItWorks/noParking.png"
import ManThrowingKeys from "../../public/static/images/png/howItWorks/manThrowingKeys.png"


const BackgroundImageLayerOne = styled.div`
  display: flex;
  height: 100%;
  flex-grow: 1;
  background-image: url(${policeWalkieTalkie});
  ${props => props.theme.media.smallDesktop`
    background-image: none;
  `};
  background-repeat: no-repeat;
  background-position: -260px 55%;
  @media (max-width: 1100px) {
    background-position: -340px 55%;
  };
  background-size: 700px 500px;
`

const BackgroundImageLayerTwo = styled.div`
  display: flex;
  height: 100%;
  flex-grow: 1;
  background-image: url(${noParking});
  ${props => props.theme.media.smallDesktop`
    background-image: none;
  `};
  background-repeat: no-repeat;
  background-position: 99% 10%;
  background-size: 90px 350px;
`

const BackgroundImageLayerThree = styled.div`
  display: flex;
  height: 100%;
  flex-grow: 1;
  background-image: url(${ManThrowingKeys});
  ${props => props.theme.media.smallDesktop`
    background-image: none;
  `};
  background-repeat: no-repeat;
  background-position: 100% 102%;
  background-size: 360px 600px;
`

const BackgroundLogos = ({ children }) => {
  return (
    <BackgroundImageLayerOne>
      <BackgroundImageLayerTwo>
        <BackgroundImageLayerThree>
          { children }
        </BackgroundImageLayerThree>
      </BackgroundImageLayerTwo>
    </BackgroundImageLayerOne>
  )
}

export default BackgroundLogos
